import React, { useState, useEffect } from "react";
import propTypes from "prop-types";
import { Tooltip } from "reactstrap";
import { width } from "../helpers";
import { getCookie, saveCookie } from '../helpers/general'
import { Dropdown, DropdownToggle, DropdownMenu, DropdownItem, } from 'reactstrap';

export const Buttons = ({ ...props }) => {
  const [sending, setSending] = useState(false);

  function handleSubmit() {
    setSending(true);
    if (!props.submit(setSending)) setSending(false);
  }

  return (
    <div
      className="row buttons"
      style={{
        justifyContent: "space-between",
        padding: "20px 20px",
      }}
    >
      {width() === "mobile" ? (
        <>
          <button
            style={{
              backgroundColor: "#3E6C84",
              alignSelf: props.retBack ? "right" : "",
            }}
            onClick={props.submit}
            disabled={props.disabledSecond}
            className="btn btn-lg btn-info col-md-4 mb-1 font-weight-bold"
          >
            {props.second}
          </button>

          {!props.retBack ? (
            <button
              style={{ color: "#e2e3e5", backgroundColor: "#3E6C84" }}
              onClick={props.goBack}
              disabled={props.disabledFirst}
              className="btn btn-lg btn-info col-md-4 mb-1 font-weight-bold "
            >
              {props.first}
            </button>
          ) : (
            ""
          )}
        </>
      ) : (
        <>
          {!props.retBack ? (
            <button
              style={{ color: "#e2e3e5", backgroundColor: "#3E6C84" }}
              onClick={props.goBack}
              disabled={props.disabledFirst}
              className="btn btn-lg btn-info col-md-4 mb-1 font-weight-bold "
            >
              {props.first}
            </button>
          ) : (
            ""
          )}

          <button
            style={{
              backgroundColor: "#3E6C84",
              alignSelf: props.retBack ? "right" : "",
            }}
            onClick={handleSubmit}
            disabled={sending || props.disabledSecond}
            className="btn btn-lg btn-info col-md-4 mb-1 font-weight-bold"
          >
            {props.second}
          </button>
        </>
      )}
    </div>
  );
};

Buttons.propTypes = {
  first: propTypes.string,
  second: propTypes.string,
  submit: propTypes.func.isRequired,
  goBack: propTypes.func.isRequired,
};

Buttons.defaultProps = {
  first: "Voltar",
  second: "Avançar",
  submit: () => false,
};

export const InputLabelAlert = ({ ...props }) => {
  const [tooltipOpen, setTooltipOpen] = useState(false);
  const [help, setHelp] = useState(false);
  // console.log("InputLabelAlert(1): ", props)
  const toggle = () => {
    if (help) {
      setTooltipOpen(false);
    } else setTooltipOpen(!tooltipOpen);
  };

  function handleHelp() {
    props.help(setHelp);
  }

  return (
    <>
      {props.label && props.type != "checkbox" ? (
        <div style={{ display: "flex" }}>
          <label
            htmlFor={props.id}
            className={
              props.className
                ? props.className
                : props.marginRight
                  ? "label"
                  : "no-margin"
            }
            style={{
              marginRight: props.marginRight ? props.marginRight : "",
            }}
          >
            {props.label} {props.cifrao && "(R$)"}{" "}
            {props.help ? (
              <span className="custom-info-flex" onClick={handleHelp}>
                ?
              </span>
            ) : (
              ""
            )}
          </label>
        </div>
      ) : (
        ""
      )}

      {!props.link &&
        <input
          className={`form-control ${props.inputClass} ${(!props.lowercase && "text-uppercase") || (props.lowercase && "text-lowercase")}`}
          type={props.type}
          name={props.id}
          id={props.id}
          step={props.step}
          value={props.value}
          onChange={props.handle || props.onChange}
          maxLength={props.length}
          onFocus={props.onFocus}
          // minLength={props.minLength}
          disabled={props.disabled}
          onBlur={props.onBlur}
          onClick={props.click}
          style={{
            borderColor: props.warning ? "red" : "",
            textAlign: props.type == "numeric" ? "right" : "left",
          }}
          list={props.list}
          autoFocus={props.focus}
          onContextMenu={props.onContextMenu}
          ref={props.ref}
          autoComplete="off"
          required={props.required}
          onPaste={props.onPaste}
        />}

      {props.link &&
        <a href={props.value?.toLowerCase()} target="_new" style={{ textDecoration: "none" }}>
          <input
            className={`form-control ${props.inputClass} ${(!props.lowercase && "text-uppercase") || (props.lowercase && "text-lowercase")}`}
            type={props.type}
            name={props.id}
            id={props.id}
            step={props.step}
            value={props.value}
            onChange={props.handle || props.onChange}
            maxLength={props.length}
            onFocus={props.onFocus}
            // minLength={props.minLength}
            disabled={props.disabled}
            onBlur={props.onBlur}
            onClick={props.click}
            style={{
              borderColor: props.warning ? "red" : "",
              textAlign: props.type == "numeric" ? "right" : "left",
              cursor: "pointer",
            }}
            list={props.list}
            autoFocus={props.focus}
            onContextMenu={props.onContextMenu}
            ref={props.ref}
            autoComplete="off"
            required={props.required}
            onPaste={props.onPaste}
            title="Clique para acessar"
          />
        </a>}

      {props.type == "checkbox" && <label for={props.id}>{props.label}</label>}

      {props.tipText ? (
        <Tooltip
          placement="bottom"
          isOpen={tooltipOpen}
          target={props.id}
          toggle={toggle}
        >
          {props.tipText}
        </Tooltip>
      ) : (
        ""
      )}

      <InputAlert
        display={props.warning}
        field={props.label}
        messages={props.field || props.messages || props.msgErro}
      />
    </>
  );
};

InputLabelAlert.propTypes = {
  id: propTypes.string.isRequired,
  label: propTypes.string.isRequired,
  value: propTypes.string.isRequired,
  handle: propTypes.func.isRequired,
  warning: propTypes.number.isRequired,
  list: propTypes.string,
  length: propTypes.string,
  // minLength: propTypes.number,
  onContextMenu: propTypes.func,
  onPaste: propTypes.func,
  inputClass: propTypes.string,
};

InputLabelAlert.defaultProps = {
  value: "",
  label: "",
  inputClass: "",
  warning: 0,
  minLength: 0,
  list: "",
  length: "",
  onContextMenu: () => true,
  onPaste: () => true,
};

export const InputAlert = ({ ...props }) => (
  <p
    className="alert alert-danger"
    style={{ display: props.display ? "block" : "none", textAlign: "left" }}
  >
    {/* {props.messages || `Favor preencher o campo: ${props.field}`} */}
    {props.messages || `Campo obrigatório ou inválido: ${props.field}`}
  </p>
);

InputAlert.propTypes = {
  display: propTypes.number,
  field: propTypes.string,
  messages: propTypes.string,
};

InputAlert.defaultProps = {
  display: 0,
};

export const Pagination = ({ ...props }) => {
  let paginas = props.total_paginas || 10;
  const [qtdLinesPage, setQtdLinesPage] = useState(getCookie({ label: "qtdLinesPage" }) || 10);

  let max =
    props?.detailed?.length > qtdLinesPage
      ? Math.ceil(props?.detailed?.length / qtdLinesPage)
      : 1;
  const [exibindo, setExibindo] = useState(0);
  const [inicio, setInicio] = useState(0);

  useEffect(() => {
    if (props.actual >= exibindo) {
      setInicio(inicio + 1);
      setExibindo(exibindo + 1);
    }
  }, [props.actual]);

  const handleQtdLinesPage = (e) => {
    setQtdLinesPage(e.currentTarget.value)
    saveCookie({ label: "qtdLinesPage", content: e.currentTarget.value });
    if (props.setQtdLinesPage)
      props.setQtdLinesPage(e.currentTarget.value)
  }

  const Paginas = () => {
    // console.log("layout.Pagination.Paginas(paginas): ", paginas)
    // console.log("layout.Pagination.Paginas(atual): ", props.actual)
    let index = [];

    let i = props.actual + 1 < paginas ? 0 : props.actual + 1 - paginas
    let tot = props.actual + 1 < paginas ? paginas : paginas + i
    if (paginas > max)
      tot = max
    for (; i < tot; i++) {
      index.push(
        <li
          style={{ cursor: "pointer" }}
          value={i}
          onClick={props.changePage}
          key={i}
          className="page-item"
        >
          <span
            className={`page-link ${props.actual === i ? "text-danger font-weight-bold" : ""
              }`}
          >
            {i < 9 ? "0" : ""}
            {i + 1}
          </span>
        </li>
      );
    }

    return index;
  };

  const handlePage = (e, proximo) => {
    if (!proximo || props.actual < max - 1)
      if (props && props.changePage) props.changePage(e);
  };

  return (
    <div className="mt-1" >
      <nav aria-label="Page navigation" style={{ marginTop: "1px !important", }}>
        <ul className="pagination justify-content-left " style={{ marginTop: "1px !important", overflowX: "auto" }}>
          <li
            style={{ cursor: "pointer", marginTop: "1px !important" }}
            value={props.actual - 1}
            onClick={(e) => (props.actual ? handlePage(e, false) : null)}
            className={`page-item ${!props.actual ? "disabled" : ""}`}
          >
            <span className="page-link">Anterior</span>
          </li>
          <Paginas />
          <li
            style={{ cursor: "pointer", marginTop: "1px !important" }}
            value={props.actual + 1}
            onClick={(e) => (props.actual < max - 1 ? handlePage(e, true) : null)}
            className={`page-item ${props.actual === max - 1 ? "disabled" : ""}`}
          >
            <span className="page-link">Próximo</span>
          </li>
          <li
            style={{ cursor: "pointer", display: "flex", alignItems: "center", textAlign: "center", justifyContent: "center" }}
            value={props.actual + 1}
            className={`page-item ${props.actual === max - 1 ? "disabled" : ""}`}
          >
            <div className="page-item ml-1" style={{ padding: "0.05rem" }}>
              <select
                defaultValue={qtdLinesPage}
                name="qtdLinesPage"
                id="qtdLinesPage"
                onChange={handleQtdLinesPage}
                style={{
                  width: "50px",
                  height: "100% !important",
                  textAlign: "center",
                  backgroundColor: "#EBEEE9",
                  borderRadius: "4px",
                  border: "1.5px solid #727476",
                  backgroundImage:
                    "linear-gradient(to top, #D1D3D4, #F7F8F9 90%)",
                }}
              >
                {[10, 20, 30, 40, 50, 100, 200,].map((lines, i) => (
                  <option
                    key={`lines-${i}`}
                    label={lines}
                    value={lines}
                  >
                    {lines}
                  </option>
                ))}
              </select>
            </div>
          </li>
        </ul>
      </nav>
    </div>
  );
};

export const FilterSelect = ({ ...props }) => {
  let options = props.detailed && props.detailed[props.oLabel];
  if (options && options.length > 0) options.sort();
  // console.log("FilterSelect - options: ", options)
  return (
    <select
      onChange={props.handleOption}
      data-label={props.oLabel}
      className="form-control"
      title="Selecione um valor para filtrar"
      style={{ lineHeight: "2.2em", fontSize: "0.8em" }}
    >
      <option value="todos">Todos</option>
      {options &&
        options.map(
          (proposta, i) =>
            proposta && <FilterOption key={proposta} value={proposta} />
        )}
    </select>
  );
};

export const FilterOption = ({ ...props }) => (
  <option key={props.key} value={props.value}>
    {props.value}
  </option>
);


export const DropDownMenu = ({ direction, ...args }) => {
  const [dropdownOpen, setDropdownOpen] = useState(false);
  const toggle = () => setDropdownOpen((prevState) => !prevState);
  // console.log("DropDownMenu - args: ", args)
  let _border = "0.01rem solid black"

  function handleClick(e) {
    console.log("Clicou: ", e)
  }

  return (
    <>
      <div className="d-flex" style={{ overflow: "hidden" }}>
        <Dropdown isOpen={dropdownOpen} toggle={toggle} direction={direction}>
          <DropdownToggle className="custom-dropdown"><i className="fa fa-cog"></i></DropdownToggle>
          <DropdownMenu {...args} positionFixed={true} >
            {args.items && args.items.map((item, i) => {
              if (!item.invisible)
                return (
                  <>
                    {!item.url &&
                      <>
                        <div style={{ borderTop: item.separatorTop ? _border : "" }}></div>
                        <DropdownItem title={item.title} onClick={item.onClick}>
                          <div style={{ color: item.color }}>
                            {item.className && <i className={`mr-2 ${item.className}`} />}{item.descricao}
                          </div>
                        </DropdownItem>
                        <div style={{ borderTop: item.separatorBottom ? _border : "" }}></div>
                      </>
                    }
                    {item.url &&
                      <>
                        <div style={{ borderTop: item.separatorTop ? _border : "" }}></div>
                        <DropdownItem title={item.title} >
                          <a href={item.url}>
                            <div style={{ color: item.color, }}>
                              {item.className && <i className={`mr-2 ${item.className}`} />}{item.descricao}
                            </div>
                          </a>
                        </DropdownItem>
                        <div style={{ borderTop: item.separatorBottom ? _border : "" }}></div>
                      </>
                    }
                  </>
                )
            })}
          </DropdownMenu>
        </Dropdown>
      </div>
    </>
    // <Dropdown toggle={function noRefCheck() { }}>
    //   <DropdownToggle
    //     data-toggle="dropdown"
    //     tag="span"
    //   >
    //     <i className="fa fa-cog"></i>
    //   </DropdownToggle>
    //   <DropdownMenu>
    //     <div onClick={function noRefCheck() { }}>
    //       Custom dropdown item
    //     </div>
    //     <div onClick={function noRefCheck() { }}>
    //       Custom dropdown item
    //     </div>
    //     <div onClick={function noRefCheck() { }}>
    //       Custom dropdown item
    //     </div>
    //     <div onClick={function noRefCheck() { }}>
    //       Custom dropdown item
    //     </div>
    //   </DropdownMenu>
    // </Dropdown>
  )
}